import { compose, bindActionCreators  } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import dataFetcher from "../../parts/chore/dataFetcher";
import { searchFlaggedMessages, clearSearch } from '../../search/searchActions';
import { resolveReport } from '../../messages/messageActions';

import Reports from './Reports';

const mapStateToProps = state => ({
  reports: state.search.messageReports.results,
  search: state.search.messageReports.search,
  pagination: state.search.messageReports.pagination,
  platformId: state.platform.platform.id
});

const mapDispatchToProps = dispatch => bindActionCreators({
  searchFlaggedMessages,
  clearSearch,
  resolveReport
 }, dispatch);

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter,
  dataFetcher
)(Reports);